<template>
  <v-dialog v-model="isShow" persistent scrollable width="800" content-class="termsDialogMargin">
    <v-card>
      <v-toolbar dark dense flat color="primary">
        <v-toolbar-title>{{editedTermTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text ref="termsBody">
        <div class="d-flex justify-end my-3 mr-3" v-if="hasDownload">
          <v-btn depressed small color="secondary" href="https://safebilling.co.kr/terms/download" target="_blank">약관 다운로드</v-btn>
        </div>
        <div v-if="isExternalTerm" class="terms-dialog-content-wrappper external" style="min-height: 70vh">
          <iframe :src="externalTermUrl"></iframe>
        </div>
        <div v-else class="terms-dialog-content-wrappper" v-html="termContent"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TermsDialog",
  props: ["isShow", "termTitle", "termContent", "isExternalTerm", "externalTermUrl", "hasDownload"],
  computed: {
    editedTermTitle() {
      return this.termTitle.replaceAll("<br/>", "")
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    }
  },

  updated() {
    this.$nextTick(() => {
      this.$refs.termsBody.scrollTop = 0;
    });
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-toolbar__title {
    font-size: rem(14px);
  }
  .v-card__text {
    padding: 0 !important;
    font-size: rem(12px);
    word-break: keep-all;

    .terms-dialog-content-wrappper {
      padding: 16px;
      &.external {
        padding: 16px 0px 16px 16px;
        display: flex;
        iframe {
          width: 100%;
          border: none;
        }
      }
    }
    table, td span {
      word-break: break-all !important;
    }
  }
  @media (max-width: 350px) {
    .termsDialogMargin {
      margin: 10px !important;
    }
  }
  @include respond-to("medium") {
    .v-toolbar__title {
      font-size: rem(16px);
    }
    .v-card__text {
      font-size: rem(13px);
      .terms-dialog-content-wrappper {
        padding: 24px;
        //padding: 4px;
      }
    }
  }


}
</style>